import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import {
  LinkComponent,
  MarkdownComponent,
  TypographyComponent,
} from '@hyperkit'

import { SharedModule } from '../modules/shared/shared.module'

import { ReleaseComponent } from './release/release.component'
import { ReleaseRoutes } from './release.routes'
import { ReleasesComponent } from './releases.component'

@NgModule({
  declarations: [ReleasesComponent, ReleaseComponent],
  imports: [
    TypographyComponent,
    LinkComponent,
    MarkdownComponent,
    SharedModule,
    CommonModule,
    RouterModule.forChild(ReleaseRoutes),
  ],
  exports: [RouterModule],
})
export class ReleaseModule {}
